import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../../../typography/Heading'
import LazyImage from '../../LazyImage'
import styles from './styles'

const ModalImageHeader = ({ imageLoader, imageWidth, text }) => (
  <div className={styles.wrapper}>
    <LazyImage loader={imageLoader} alt={text} width={imageWidth} className={styles.image} />
    <Heading>
      <strong>{text}</strong>
    </Heading>
  </div>
)

ModalImageHeader.propTypes = {
  imageLoader: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  imageWidth: PropTypes.number,
}

export default ModalImageHeader
